// extracted by mini-css-extract-plugin
module.exports = {"container":"Table_container__1-5gn","tableNum":"Table_tableNum__2N1Cn","addIcon":"Table_addIcon__-3CKE"};